import { PulseStatusVariant } from "../pulseStatusVariant";
import styles from "./PulseStatusBadge.module.scss";

type Props = {
  variant: PulseStatusVariant;
  text: string;
};

const PulseStatusBadge = ({ variant, text }: Props) => {
  return <span className={`${styles.badge} ${styles[variant]}`}>{text}</span>;
};

export default PulseStatusBadge;
